/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { notification } from 'antd';
import { useNavigate, useParams } from 'react-router';

import { useAppDispatch, useAppSelector } from 'store';
import { serializeSelectPriorityItem } from 'utils/mappings';
import { StatusesEnum } from 'constants/status';
import CardSpin from 'components/Card/CardSpin';
import { IFormProps, SampleEditForm } from 'components/Sample/SampleEditForm';
import { urls } from 'store/api';
import { EntitySelect } from 'components/form/AsyncSelect/EntitySelect';
import {
  bulkUpdateArticlesItem,
  loadArticlesItem,
} from 'store/slices/articles/actions';
import { IArticlesItem } from 'store/slices/articles/interfaces';

interface IProps {
  sortFieldName?: keyof Pick<
    IArticlesItem,
    'sortPriority' | 'sortPriorityMainPage'
  >;
  slug: string;
  params?: Record<string, any>;
}

export const Edit: React.FC<IProps> = ({
  sortFieldName = 'sortPriority',
  slug,
  params = {},
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [queryLoading, setQueryLoading] = useState(!!id);
  const data = useAppSelector(state => state.articles);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onSubmit = (params: IFormProps<IArticlesItem>) => {
    const data = params.values;
    const prevItem =
      id && Number(id) != data.id
        ? { id: Number(id), [sortFieldName]: null }
        : {};
    const updateElements = [
      {
        id: data.id,
        [sortFieldName]: params.sortPriority,
      },
      prevItem,
    ].filter(el => el.id);
    dispatch(bulkUpdateArticlesItem(updateElements))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно изменена',
        });
        navigate(slug);
      })
      .catch(() => setIsLoading(false));
  };

  const handleCancel = () => {
    navigate(slug);
  };

  const initialValues = serializeSelectPriorityItem({
    values: data.item,
    sortFieldName,
  });

  useEffect(() => {
    if (id) {
      dispatch(loadArticlesItem(id))
        .unwrap()
        .finally(() => {
          setQueryLoading(false);
        });
    }
  }, [id]);

  if (queryLoading) {
    return <CardSpin />;
  }

  const Select = () => (
    <EntitySelect
      name='values'
      label='Статья'
      placeholder='Выберите статью'
      additional={{
        name: undefined,
        status: StatusesEnum.PUBLISHED,
        sort: `${sortFieldName}`,
        ...params,
      }}
      required
      requestUrl={urls.api.articles.get}
    />
  );

  return (
    <SampleEditForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      handleCancel={handleCancel}
      isLoading={isLoading}
      select={Select}
    />
  );
};
